export default __webpack_public_path__ + "static/media/MG1.c9a892aa.png";